"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = _default;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

var _DataStore = _interopRequireDefault(require("../../../../KESI2/Stores/DataStore2"));

var _DrupalSelfReflectNugget = _interopRequireDefault(require("./DrupalSelfReflectNugget.scss"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _Image = _interopRequireDefault(require("../../Image/Image"));

var equeoStyle = (0, _makeStyles["default"])({
  root: {
    color: function color(props) {
      return props.color;
    },
    height: 300
  },
  thumb: {
    height: 20,
    width: 50,
    borderRadius: 0,
    marginLeft: '-23px !important'
  },
  active: {},
  track: {
    color: function color(props) {
      return props.color;
    },
    height: 8,
    borderRadius: 4,
    width: 10
  },
  rail: {
    opacity: 1,
    color: function color(props) {
      return props.color;
    },
    height: 8,
    borderRadius: 4,
    width: 10
  }
});

function _default(props) {
  var _useState = (0, _react.useState)(5),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      userInput = _useState2[0],
      setUserInput = _useState2[1];

  var onChangeCommited = function onChangeCommited(evt, value) {
    console.log('onChangeCommited', value);

    if (props.dataStorePath) {
      _DataStore["default"].setSingleData(props.dataStorePath, value);
    }
  };

  var onChange = function onChange(evt, value) {
    console.log('onChange', value);
    setUserInput(value);
  };

  var style = equeoStyle(props);
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: "column",
    alignItems: "center",
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    className: _DrupalSelfReflectNugget["default"].resultLabel
  }, props.maxImage ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    alt: 'Icon passend zum Maximalwert der Selbsteinschätzung',
    className: _DrupalSelfReflectNugget["default"].maxImage,
    src: "".concat(props.path).concat(props.maxImage)
  }) : null, props.maxText ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _DrupalSelfReflectNugget["default"].maxText,
    dangerouslySetInnerHTML: {
      __html: props.maxText
    }
  }) : null, /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: true,
    className: _DrupalSelfReflectNugget["default"].sliderContainer
  }, /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    classes: {
      root: style.root,
      track: style.track,
      thumb: style.thumb,
      rail: style.rail
    },
    orientation: "vertical",
    value: userInput,
    min: 0,
    max: 10,
    onChange: onChange,
    onChangeCommitted: onChangeCommited
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    className: _DrupalSelfReflectNugget["default"].resultLabel
  }, props.minImage ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    alt: 'Icon passend zum Minimalwert der Selbsteinschätzung',
    className: _DrupalSelfReflectNugget["default"].minImage,
    src: "".concat(props.path).concat(props.minImage)
  }) : null, props.minText ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _DrupalSelfReflectNugget["default"].minText,
    dangerouslySetInnerHTML: {
      __html: props.minText
    }
  }) : null));
}